import { format, subDays } from 'date-fns'
import { ICargoFilters } from './componenets/cargo-filters'
import { CargoStatus } from './content/select-n-autocomplete-options'

export const minCharsForAutocomplete = 2

export const toBeNamedText = 'TBN'
export const tradingWorldwide = 'Trading worldwide'

export const dateFormatAcceptedByApi = 'yyyy-MM-dd'

export const statusesNeedingPeriodFilter: CargoStatus[] = [
  CargoStatus.Fixed,
  CargoStatus.Withdrawn,
  CargoStatus.Failed,
]

export const cargoStatusesWithHiddenFormFields = [
  CargoStatus.Open,
  CargoStatus.Poss,
  CargoStatus.OnHold,
]

export enum CargoListPageSearchParams {
  readCargo = 'read-cargo',
  editCargo = 'edit-cargo',
  recreateCargo = 'recreate-cargo',
  duplicateCargo = 'duplicate-cargo',
  createCargo = 'create-cargo',
  cargoGrade = 'cargo-grade',
  pools = 'pools',
  worldArea = 'world-area',
  limitFrom = 'period-from',
  limitTo = 'period-to',
  cargoType = 'cargo-type',
  orderByDate = 'order-by-date',
  orderByField = 'order-by-field',
  pic = 'pic',
  charterer = 'charterer',
  loadPort = 'load-port',
  dischargePort = 'discharge-port',
  showDateQuoted = 'show-date-quoted',
  quantityFrom = 'quantity-from',
  quantityTo = 'quantity-to',
  archived = 'archived',
  vessel = 'vessel',
}

export const numberOfDaysInPast = 7

export const defaultFilters: ICargoFilters = {
  [CargoListPageSearchParams.cargoGrade]: [],
  [CargoListPageSearchParams.pools]: [],
  [CargoListPageSearchParams.worldArea]: [],
  [CargoListPageSearchParams.limitFrom]: format(
    subDays(new Date(), numberOfDaysInPast),
    dateFormatAcceptedByApi,
  ),
  [CargoListPageSearchParams.limitTo]: format(
    new Date(),
    dateFormatAcceptedByApi,
  ),
  [CargoListPageSearchParams.cargoType]: ['SPOT', 'T/C'],
  [CargoListPageSearchParams.pic]: [],
  [CargoListPageSearchParams.charterer]: [],
  [CargoListPageSearchParams.loadPort]: [],
  [CargoListPageSearchParams.dischargePort]: [],
  [CargoListPageSearchParams.showDateQuoted]: 'false',
  [CargoListPageSearchParams.quantityFrom]: undefined,
  [CargoListPageSearchParams.quantityTo]: undefined,
  [CargoListPageSearchParams.archived]: 'false',
  [CargoListPageSearchParams.vessel]: [],
}

export const CargoTableSectionTitle = {
  openPossOnHold: 'Open / Poss / On Hold',
  onSubs: 'On Subs',
  fixedFailedWithdrawn: 'Fixed / Failed / Withdrawn',
  archived: 'Archived',
} as const

export interface CargoTableSection {
  statuses: CargoStatus[]
  title: (typeof CargoTableSectionTitle)[keyof typeof CargoTableSectionTitle]
}

export const cargoTableSections: CargoTableSection[] = [
  {
    statuses: [CargoStatus.Open, CargoStatus.Poss, CargoStatus.OnHold],
    title: CargoTableSectionTitle.openPossOnHold,
  },
  {
    statuses: [CargoStatus.OnSubs],
    title: CargoTableSectionTitle.onSubs,
  },
  {
    statuses: [CargoStatus.Fixed, CargoStatus.Failed, CargoStatus.Withdrawn],
    title: CargoTableSectionTitle.fixedFailedWithdrawn,
  },
]

export const archivedCargoTableSection: CargoTableSection = {
  statuses: [CargoStatus.Archived],
  title: CargoTableSectionTitle.archived,
}

export const cargoStatusesReflectedOnPositionList = [
  CargoStatus.Fixed,
  CargoStatus.OnSubs,
  CargoStatus.Failed,
]

export const forAllPortsLabel = 'For all ports'
